const listeners = new Set();

export function onCashSessionChanged(callback) {
  if (typeof callback !== "function") {
    return () => {};
  }

  listeners.add(callback);

  return () => {
    listeners.delete(callback);
  };
}

export function emitCashSessionChanged(payload = {}) {
  listeners.forEach((listener) => {
    try {
      listener(payload);
    } catch {
      // Ignore listener errors to keep emitter resilient.
    }
  });
}

